
import { Table, TableBody, ButtonGroup, Modal, Badge, TableCell, TableContainer, TableHead, TableRow,  Checkbox, AppBar, Box, Toolbar, TextField, useTheme, IconButton, Button, Menu, MenuItem, ListItemIcon, ListItemText, Typography, Divider, CssBaseline, Tooltip } from "@mui/material";
import React, { useState, useEffect } from "react";

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import HelpIcon from '@mui/icons-material/HelpOutline';

import ViewListIcon from '@mui/icons-material/ViewList';

import CloseIcon from '@mui/icons-material/Close';
import Close from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';

import { tokens } from "../../../theme/theme";
// import '../../../components/boxstyles.css';

import Searchicon from '@mui/icons-material/Search';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

import AddNewPurchaseReceive from "./AddPurchaseReceives";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import PurchaseOrder from "../order/PurchaseOrder";
import usePurchaseReceivedList from "../../../hooks/usePurchaseReceivedList";
import usePurchaseOrderList from "../../../hooks/usePurchaseOrderList";

const PurchaseReceives = ({ handleBackWinderMachineEntry }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Goods Receives');
    
    const [selectedStatus, setSelectedStatus] = useState('All');
    const openFirst = Boolean(anchorElFirst);
    const [newVendor, setNewVendor] = useState(false);
    const [viewPO, setViewPO] = useState(false);

    const [vendorHome, setVendorHome] = useState(true);

    const [selectedRows, setSelectedRows] = useState([]);
    const [showFirstToolbar, setShowFirstToolbar] = useState(true);
    const [showNewToolbar, setShowNewToolbar] = useState(false);
    const [notification, setNotification] = useState(0);

    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    // const [selectedOptionSecond, setSelectedOptionSecond] = useState('');
    const openSecond = Boolean(anchorElSecond);

    const [anchorElMenu, setAnchorElMenu] = useState(null);
    

    const { receivedData, refreshReceivedListSummary, } = usePurchaseReceivedList('all');
    const { orderData, setOrderData } = usePurchaseOrderList();

    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'All Goods Receives') {
            setSelectedStatus('All');
        }
        else if (option === 'In Transit') {
            setSelectedStatus('InTransit');
        }
        else if (option === 'Received') {
            setSelectedStatus('Received');
        }

        else if (option === 'Billed') {
            setSelectedStatus('Billed');
        }
        else if (option === 'Partially Billed') {
            setSelectedStatus('PartiallyBilled');
        }


        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
        handleMenuCloseSecond();
    };
    const [editPurchaseOrderNumber, setEditPurchaseOrderNumber] = useState(0);
    const [editPurchaseReceiveNumber, setEditPurchaseReceiveNumber] = useState('');
    const [editPurchaseReceiveID, setEditPurchaseReceiveID] = useState(0);

    const handleShowNewVendor = () => {
        setEditPurchaseReceiveID(0);
        setEditPurchaseOrderNumber(0);
        setEditPurchaseReceiveNumber('');
        setVendorHome(false);
        setNewVendor(true);
        setViewPO(false);
    }

    const handleShowPurchaseOrderList = () => {
        setEditPurchaseReceiveID(0);
        setEditPurchaseOrderNumber(0);
        setEditPurchaseReceiveNumber('');
        setVendorHome(false);
        setNewVendor(false);
        setViewPO(true);
    }

    const handleCallEdit = (value, poID, poNumber) => {
        setEditPurchaseReceiveID(value);
        setEditPurchaseOrderNumber(poID);
        setEditPurchaseReceiveNumber(poNumber);
        setVendorHome(false);
        setNewVendor(true);
    };


    const handlecallback = async () => {
        setVendorHome(true);
        setNewVendor(false);
        setViewPO(false);
        await refreshReceivedListSummary('all');
    }

    useEffect(() => {
        if (orderData?.length > 0) {
            setNotification(orderData.length);
        }
    }, [orderData, setOrderData]);

    const [open, setOpen] = useState(false);
    const [filters, setFilters] = useState({
        date: '',
        purchaseOrder: '',
        partyName: '',
        status: '',
        received: '',
        billed: '',
        amount: '',
        expectedDeliveryDate: '',
    });

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelectedRows = receivedData.map((row) => row.id);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);
    };

    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);

        if (newSelectedRows.length > 0) {
            setShowNewToolbar(true); // Show new toolbar when rows are selected
            setShowFirstToolbar(false);
        } else {
            setShowNewToolbar(false); // Hide new toolbar when no rows are selected
            setShowFirstToolbar(true);
        }
    };

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;



    const filteredData = receivedData.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const handleNewToolbarClose = () => {
        setShowNewToolbar(false); // Hide new toolbar
        setShowFirstToolbar(true);
    };

    const handleBulkUpdate = () => {
        console.log('Bulk Update');
    };

    const handleMarkAsIssued = () => {
        console.log('Mark as Issued');
    };

    const handleBulkCancelItems = () => {
        console.log('Bulk Cancel Items');
    };

    const handleBulkReopenCancelledItems = () => {
        console.log('Bulk Reopen Cancelled Items');
    };

    const handleConvertToBill = () => {
        console.log('Convert to Bill');
    };

  

    return (
        <Box >
            <CssBaseline />
            {vendorHome && (

                <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                    <Toolbar>
                        {/* First Menu */}
                        {showFirstToolbar && (
                            <>
                                <Button
                                    color="secondary"
                                    onClick={handleMenuClickFirst}
                                    endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                                    sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                                >
                                    {selectedOptionFirst}
                                </Button>
                                <Menu
                                    anchorEl={anchorElFirst}
                                    open={openFirst}
                                    onClose={handleMenuCloseFirst}

                                >
                                    <MenuItem onClick={() => handleMenuItemClickFirst('All Goods Receives')}>All </MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickFirst('In Transit')}>In Transit</MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickFirst('Received')}>Received</MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickFirst('Billed')}>Billed</MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickFirst('Partially Billed')}>Partially Billed</MenuItem>
                                </Menu>

                                {/* Adding margin-left: auto to push the button to the right */}
                                <Button size="small" variant="contained" onClick={handleShowPurchaseOrderList} color="secondary"
                                    startIcon={
                                        <Badge
                                            badgeContent={notification}
                                            color="error"
                                            overlap="circular"
                                            sx={{
                                                "& .MuiBadge-badge": {
                                                    fontSize: "10px",
                                                    height: "16px",
                                                    minWidth: "16px",
                                                    padding: "0 4px",
                                                },
                                            }}
                                        >
                                            <ViewListIcon sx={{ fontSize: "18px" }} />
                                        </Badge>
                                    } sx={{ marginLeft: 'auto', textTransform: 'none' }}>View Purchase Order</Button>
                                <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} sx={{ marginLeft: "5px", textTransform: 'none' }}>New</Button>
                                {/* {formMode === 0 ? (
                                    <>
                                        <Button size="small" variant="contained" onClick={handleShowRequestIndentList} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>View Request Indent</Button>
                                        <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} sx={{ marginLeft: "5px", textTransform: 'none' }}>New</Button>
                                    </>
                                ) : (

                                    < Button size="small" disabled variant="contained" onClick={handleShowNewVendor} color="secondary" sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button>
                                )} */}




                                {/* Second Menu */}
                                <IconButton
                                    size="small"
                                    // edge="start"
                                    color="secondary"
                                    aria-label="menu"
                                    sx={{ ml: 2 }}
                                    onClick={handleMenuClickSecond}
                                >
                                    <MoreVertIcon sx={{ fontSize: "18px" }} />
                                </IconButton>
                                <Menu
                                    anchorEl={anchorElSecond}
                                    open={openSecond}
                                    onClose={handleMenuCloseSecond}
                                >
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Import Purchase Receives')}>
                                        <ListItemIcon>
                                            <ImportExportIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Import Purchase Receives" />
                                    </MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Export Purchase Receives')}>
                                        <ListItemIcon>
                                            <FileDownloadIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Export Purchase Receives" />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                        <ListItemIcon>
                                            <ListAltIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Preference " />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                        <ListItemIcon>
                                            <RefreshIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Refresh List" />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>

                                        <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                            Reset Columns Width
                                        </Button>
                                    </MenuItem>
                                </Menu>

                                <IconButton
                                    size="small"
                                    aria-label="menu"
                                    sx={{ mr: 1, ml: 1 }}
                                    onClick={handleMenuClickSecond}
                                >
                                    <HelpIcon sx={{ fontSize: "18px" }} />
                                </IconButton>
                                <div>
                                    <IconButton onClick={handleBackWinderMachineEntry} >
                                        <Close fontSize="inherit" style={{ color: "#2196F3", fontSize: "18px" }} />
                                    </IconButton>
                                </div>
                            </>
                        )}

                        {showNewToolbar && (
                            <>
                                <Button
                                    variant="outlined"
                                    color="secondary"

                                    onClick={handleMenuClickFirst}
                                    endIcon={<ArrowDropDownIcon sx={{ color: "teal" }} />}
                                    sx={{ textTransform: 'none', fontSize: "10px", fontWeight: "bold" }}
                                >
                                    {/* {selectedOptionFirst} */}
                                    <Typography variant="h6">
                                        Bulk Updates
                                    </Typography>
                                </Button>
                                <Menu
                                    anchorEl={anchorElFirst}
                                    open={openFirst}
                                    onClose={handleMenuCloseFirst}

                                >
                                    <MenuItem onClick={() => handleBulkUpdate()}>Bulk Update </MenuItem>
                                    <MenuItem onClick={() => handleMarkAsIssued()}>Mark as Issued</MenuItem>
                                    <MenuItem onClick={() => handleBulkCancelItems()}>Bulk Cancel Items</MenuItem>
                                    <MenuItem onClick={() => handleBulkReopenCancelledItems()}>Bulk reopen Canceled items</MenuItem>
                                    <MenuItem onClick={() => handleConvertToBill()}>Convert to Bill</MenuItem>

                                </Menu>



                                <ButtonGroup color="secondary" variant="outlined" style={{ marginLeft: 10 }}>
                                    <Button aria-label="email" sx={{ padding: "6px", minWidth: 40 }}>
                                        <EmailIcon style={{ fontSize: "20px", color: "#5c6bc0" }} />
                                    </Button>
                                    <Button aria-label="pdf" sx={{ padding: 0, minWidth: 40 }}>
                                        <PictureAsPdfIcon style={{ fontSize: "20px", color: "#d32f2f" }} />
                                    </Button>
                                    <Button aria-label="print" sx={{ padding: 0, minWidth: 40 }}>
                                        <PrintIcon style={{ fontSize: "20px", color: "#64b5f6" }} />
                                    </Button>
                                </ButtonGroup>
                                <ButtonGroup color="secondary" variant="outlined" style={{ marginLeft: 10 }}>
                                    <Button aria-label="delete" sx={{ padding: "6px", minWidth: 40 }}>
                                        <DeleteIcon style={{ fontSize: "20px", color: "#ff7043" }} />
                                    </Button>
                                </ButtonGroup>
                                <IconButton size="small" aria-label="close" sx={{ marginLeft: 2 }} >
                                    <FiberManualRecordIcon sx={{ fontSize: "12px", color: "green" }} />
                                </IconButton>
                                <Typography variant="h6" >
                                    {`${selectedRows.length} Purchase Order${selectedRows.length > 1 ? 's' : ''} selected`}
                                </Typography>


                                <IconButton size="small" aria-label="close" sx={{ marginLeft: 'auto', mr: 1 }} onClick={handleNewToolbarClose}>
                                    <CloseIcon />
                                </IconButton>
                            </>
                        )}
                    </Toolbar>
                </AppBar>
            )}

            {vendorHome && (
                <CustomTableContainer colors={colors}>
                    <TableContainer >
                        <Table size="small">
                            <TableHead sx={{ height: 10 }}>
                                <TableRow>
                                    <TableCell>
                                        <Checkbox size="small" style={{ color: "secondary" }}
                                            indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length}
                                            checked={selectedRows.length === filteredData.length}
                                            onChange={handleSelectAllClick}
                                        />
                                    </TableCell>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Purchase Receive#</TableCell>
                                    <TableCell>Purchase Order#</TableCell>
                                    <TableCell>Party Name</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Billed</TableCell>
                                    <TableCell>Quantity</TableCell>

                                    <TableCell>
                                        <IconButton onClick={handleOpen}>
                                            <Searchicon style={{ fontSize: "16px" }} />
                                        </IconButton>
                                        <Modal
                                            open={open}
                                            onClose={handleClose}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                <TextField
                                                    label="Date"
                                                    name="date"
                                                    value={filters.date}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Purchase Receives"
                                                    name="purchaseReceives"
                                                    value={filters.prnumber}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Party Order"
                                                    name="partyOrder"
                                                    value={filters.ponumber}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Comapny Name"
                                                    name="companyName"
                                                    value={filters.companyname}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Status"
                                                    name="status"
                                                    value={filters.status}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />

                                                <TextField
                                                    label="Billed"
                                                    name="billed"
                                                    value={filters.billed}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Quantity"
                                                    name="quantity"
                                                    value={filters.quantity}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />

                                                <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                    Apply Filter
                                                </Button>
                                            </Box>
                                        </Modal>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell>
                                            <Checkbox
                                                size="small"
                                                checked={isSelected(row.id)}
                                                onChange={(event) => handleRowCheckboxClick(event, row.id)}
                                            />
                                        </TableCell>
                                        <TableCell>{row.date}</TableCell>
                                        <TableCell>
                                            <span
                                                style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                onClick={() => handleCallEdit(row.id, row.po_id, row.prnumber)}
                                            >
                                                {row.prnumber}
                                            </span>
                                        </TableCell>
                                        <TableCell>{row.ponumber}</TableCell>
                                        <TableCell>{row.companyname}</TableCell>
                                        <TableCell>{row.status}</TableCell>

                                        <TableCell>{row.billed === 'Yes' ? (
                                            <Tooltip title="Billed">
                                                <FiberManualRecordIcon sx={{ fontSize: '12px', color: '#1de9b6' }} />
                                            </Tooltip>
                                        ) : (
                                            <Tooltip title="Not Billed">
                                                <FiberManualRecordIcon sx={{ fontSize: '12px', color: '#616161' }} />
                                            </Tooltip>

                                        )}</TableCell>
                                        <TableCell>{row.quantity}</TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CustomTableContainer>
            )}


            {/* New Vendor */}
            {newVendor && (
                <>
                    <AddNewPurchaseReceive handlecallback={handlecallback} editPurchaseOrderNumber={editPurchaseOrderNumber} editPurchaseReceiveNumber={editPurchaseReceiveNumber} editPurchaseReceiveID={editPurchaseReceiveID} />
                </>

            )}

            {viewPO && (
                <PurchaseOrder handleBackWinderMachineEntry={handlecallback} />
            )}



        </Box>
    );
}

export default PurchaseReceives;





